<template>
  <div id="app">
    <h1><img id="yubaba" src="./assets/yubaba.jpg"  alt="湯婆婆"></h1>
    <div>
      <form @submit.prevent="sign($auth.currentUser.uid,name,token)">
        <p>{{yubaba}}</p>
        <label for="name-input">署名</label>
        <input id="name-input" type="text" v-model.trim="name" :disabled="state!==0">
      <button type="submit">{{btnMsg}}</button>
      </form>
    </div>

    <div class="contract-paper">
      <div class="signature-line tate">
        <div class="inline-block signature-parts">甲</div>
            <char v-for="(c,i) in nameSeparatedArray" :char="c" :key="c+i" :is-show="isShow(c,i,nameSeparatedArray,newName)" />

    </div>
      <div class="signature-line tate">
        <span class="inline-block signature-parts">
        乙
        </span>
        <span class="inline-block signature-parts">
        油屋当主
        </span>
        <span class="inline-block signature-parts">
        湯婆婆
        </span>

      </div>
      <div class="contract-body" >
      <tategaki :text="'右の通り約定をpiyopiyo'"/>
      <tategaki :text="'をすることをhugahuga'"/>
      <tategaki :text="'甲はhogehoge'"/>
      <tategaki :text="'契約書'" :optional-class="'contract-title'"/>
      </div>
  </div>
      <share :text="tweetText()"/>
  <div>
    <h2>
      元ネタなど
    </h2>
    <ul>
      <li>おそらく元ネタ:
        <a href="https://twitter.com/kos59125/status/338981312192974848">@kos59125さんのツイート</a>
      </li>
      <li>
        事の発端: <a href="https://qiita.com/Nemesis/items/c7192a7c510788d2cba2">@Nemesis
『Javaで湯婆婆を実装してみる』</a>
      </li>
      <li>このページを作るきっかけ: 
        <a href="https://qiita.com/advent-calendar/2020/yubaba">湯婆婆 Advent Calendar 2020</a>
        </li>
        <li>多分Javascriptで最初に湯婆婆した人: 
          <a href="https://qiita.com/hato-poppo/items/670d5186c2807a5f51b4">
@hato-poppo『JavaScriptで湯婆婆を実装してみる』</a>
          </li>
    </ul>
    </div>
    <div>
    <h2>
      このページについて
    </h2>
      <p>Qiitaにて開催中の<a href="https://qiita.com/advent-calendar/2020/yubaba">湯婆婆 Advent Calendar 2020</a>に投稿予定(12月10日現在)のFirebase湯婆婆の動作デモページです。</p>
      <p>Firebaseの機能のうち使用しているのはAuthentication/Cloud Functions/Cloud Firestore/Cloud Messagingです。</p>
      <p>あとGCPのCloud schedulerも使用しています。</p>
      <p>サイトの設定で通知を許可していると、早朝7時にハクが通知をくれます。原作準拠なのでこの時間です。</p>
      <p>湯婆婆の契約書に署名する場合は自己責任でお願いします。</p>
      <p>契約書は毎朝7時に削除していますが、良識の範囲内で署名してください。</p>
      <p>Firebaseの認証機能を使用していますが、匿名認証のためメールアドレス等は収集しておりませんのでご安心ください。</p>
      </div>   
    </div>
</template>

<script>
import Tategaki from './components/Tategaki.vue';
import Char from './components/Char.vue'
import Share from './components/Share.vue'

export default {
  name: 'App',
  components: {
    Char,
    Tategaki,
    Share,
  },
  data(){
    return {
      state:0,
      name:'',
      newName :"",
      token:'',
      resultListener:null
    }
  },
  computed:{
    // splitメソッドで分割するとサロゲートペアが壊れる。
    nameSeparatedArray(){
      if(typeof this.name !== 'string') return []
      return [...this.name]

  },
  btnMsg(){
    if(this.state===2) return 'やり直す'
     return '記'
  },
  yubaba(){
    if(this.state===0) return "契約書だよ。そこに名前を書きな"
    if(this.state===1) return `フン。${this.name}というのかい。贅沢な名だねぇ。`
    if(this.state===2 && this.newName) return `フン。${this.name}というのかい。贅沢な名だねぇ。今からお前の名前は『${this.newName}』だ。いいかい、『${this.newName}』だよ。分かったら返事をするんだ、『${this.newName}』!!`
    return '湯婆婆 は動作を停止しました。問題の解決策をオンラインで確認できます。'
  }
},
created(){
  // 匿名認証を行う。
  const user = this.$auth.currentUser
  if(!user){
    this.$auth.signInAnonymously().catch(()=>{
      this.hasError()
    })
  }
  if(this.$messaging){
    try{

      this.$messaging.getToken({vapidKey: this.$vapiKey}).then((currentToken) => {
        if (currentToken) {
          this.token = currentToken
  }
}).catch(() => {  this.token=''
});
        }
        catch(_){
          alert('プッシュ通知機能非対応です。')
          this.token=''
        }
  }
},
beforeDestroy(){
  this.disconnect()
},
    methods:{
      isShow(char,index,nameArray,newName){
        // 契約前なら表示
        if(!newName) return true
        // 契約後で新しい名前と同じで無ければ非表示
        if(char !== newName) return false
        // 新しい名前と同じだが、重複している場合は最初に出てきた部分のみを表示する
        const firstWordIndex = nameArray.findIndex(c=>c===newName)
        if(firstWordIndex < index) return false
        return true
      },
      sign(uid,name,token){
        if(!uid ) return
        if(this.state===1) return
        if(this.state==2){
          this.reset()
          return
        }
        this.disconnect()
        this.$db.collection('contract').add({
          uid,
          name,
          newName:null,
          token:token||'',
          isFinished:false,
          createdDate:this.$fieldValue.serverTimestamp()
        }).then((result)=>{
          this.resultListener = this.onSnapshot(result)
          this.state=1
        }).catch(()=>{
          this.hasError()
        })
      },
      hasError(){
        this.state=2
        this.newName=''
        this.disconnect()
      },
      async onSnapshot(docRef){
        return await docRef.onSnapshot(doc=>{
          const data =doc.data()
          if(data.isFinished){
            setTimeout(()=>{
            this.newName = data.newName
            this.state=2
            this.disconnect()
            },1000)
          }
        })
      },
    disconnect(){
      if(typeof this.resultListener=== 'function'){
        this.resultListener()
      }
    },
    reset(){
      this.state=0
      this.name=''
      this.newName=''
    },
    tweetText(){
      return `Firebase湯婆婆「${this.yubaba}」`
    }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}

#yubaba
{
  width: 95vw;
  max-width: 700px;
}

.contract-paper{
  display:inline-block;
  background-color: wheat;
  margin:auto;
  max-width: 700px;
  width: 90vw;
  height:60vh;
  border-style: none;
  display:flex;
  text-align: right;
}

.contract-body {
  display: flex;
  text-align: left;
  margin-left: auto;
  margin-right:1rem;
  font-size: 110%
}

.contract-title{
  margin:2rem;
  font-size:200%
}

.signature-line{
  font-size:27px;
  margin-left: 2.5rem;
  vertical-align: auto;
  text-align: left;
}

@media screen and (max-width:550px){
 .contract-title{
  margin:2rem 0rem;
}
.signature-line{
  font-size:27px;
  margin-left: 1.5rem;
}
}

.signature-parts{
  vertical-align: top;
  margin-bottom:1rem
}

.inline-block{
  display: inline-block;
}

li{
  list-style:none;
}
</style>
